// extracted by mini-css-extract-plugin
export var errorIcon = "_nk-1";
export var nameLogo = "_nk-0";